import React from "react";
import { NavbarCMS, TableVideos } from "../../components";
import { useSelector } from "react-redux";

const VideosPageAdmin = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.publication_video?.navbar} />
            <TableVideos />
        </div>
    )
}

export default VideosPageAdmin;